module.exports = __webpack_public_path__ + "img/icon_invoice.fa3c0c4d.png";